import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetEnglishIqResultV2Request } from './get-english-iq-result-v2-request';
import type { IGetEnglishIqResultV2Response } from './get-english-iq-result-v2-response';
import { getEnglishIqResultV2ResponseSchema } from './get-english-iq-result-v2-response';

export async function getEnglishIqResultV2Api(
  request: IGetEnglishIqResultV2Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetEnglishIqResultV2Response>> {
  return getRequest<IGetEnglishIqResultV2Response>({
    options,
    path: `/english-iq/result/${encodeURIComponent(request.shareId)}/v2`,
    schema: getEnglishIqResultV2ResponseSchema,
  });
}
